<bazis-button
    fill="clear"
    (click)="printPage()"
>
    <bazis-icon
        slot="icon-only"
        name="print"
    ></bazis-icon>
</bazis-button>
